import React, { useState, useEffect } from 'react';
import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

const AuthWrapper: React.FC = () => {
  const [authMode, setAuthMode] = useState<'login' | 'register' | 'forgot' | 'reset'>('login');
  const [resetToken, setResetToken] = useState<string>('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('reset');
    if (token) {
      setResetToken(token);
      setAuthMode('reset');
      // Clean URL
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  const toggleMode = () => {
    setAuthMode(authMode === 'login' ? 'register' : 'login');
  };

  const handleForgotPassword = () => {
    setAuthMode('forgot');
  };

  const handleBackToLogin = () => {
    setAuthMode('login');
  };

  const handleForgotPasswordSuccess = () => {
    // Başarılı olduğunda login'e geri dön
    setAuthMode('login');
  };

  return (
    <div className="auth-wrapper">
      {authMode === 'login' ? (
        <Login onToggleMode={toggleMode} onForgotPassword={handleForgotPassword} />
      ) : authMode === 'register' ? (
        <Register onToggleMode={toggleMode} />
      ) : authMode === 'reset' ? (
        <ResetPassword token={resetToken} onBackToLogin={handleBackToLogin} />
      ) : (
        <ForgotPassword 
          onSuccess={handleForgotPasswordSuccess} 
          onBackToLogin={handleBackToLogin} 
        />
      )}
    </div>
  );
};

export default AuthWrapper;
